/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S5_Li5Inputs */

const tr_mesafeli_s5_li5 = /** @type {(inputs: Mesafeli_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Havale/EFT ile başlatılan bir sipariş, bedeli 7 (yedi) gün içinde Sağlayıcı hesabına ulaşmazsa kendiliğinden düşer; abonelik bedelleri dönem başında peşin alındığından ödenmemiş bir abonelik bedeli doğmaz ve bu sebeple hesap askıya alınmaz.`)
};

const en_mesafeli_s5_li5 = /** @type {(inputs: Mesafeli_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`An order initiated by bank transfer/EFT lapses automatically if the amount does not reach the Provider's account within 7 (seven) days; as subscription fees are collected in advance at the start of the period, no unpaid subscription fee arises and the account is not suspended for that reason.`)
};

const de_mesafeli_s5_li5 = /** @type {(inputs: Mesafeli_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine per Überweisung/EFT begonnene Bestellung verfällt von selbst, wenn der Betrag nicht innerhalb von 7 (sieben) Tagen auf dem Konto des Anbieters eingeht; da Abonnementgebühren zu Beginn des Zeitraums im Voraus erhoben werden, entsteht keine unbezahlte Abonnementgebühr, und das Konto wird aus diesem Grund nicht gesperrt.`)
};

const ru_mesafeli_s5_li5 = /** @type {(inputs: Mesafeli_S5_Li5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Заказ, начатый банковским переводом/EFT, автоматически аннулируется, если сумма не поступит на счёт Поставщика в течение 7 (семи) дней; поскольку абонентская плата взимается авансом в начале периода, неоплаченной абонентской платы не возникает и аккаунт по этой причине не блокируется.`)
};

/**
* | output |
* | --- |
* | "An order initiated by bank transfer/EFT lapses automatically if the amount does not reach the Provider's account within 7 (seven) days; as subscription fees ..." |
*
* @param {Mesafeli_S5_Li5Inputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s5_li5 = /** @type {((inputs?: Mesafeli_S5_Li5Inputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S5_Li5Inputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s5_li5(inputs)
	if (locale === "de") return de_mesafeli_s5_li5(inputs)
	if (locale === "ru") return ru_mesafeli_s5_li5(inputs)
	return tr_mesafeli_s5_li5(inputs)
});